// We use a separate type for the input values rather than VideoConfig directly so that this utils file can
// be used by both sites-admin-spa and sites-web (as each has their own VideoConfig type).
export type VideoConfigUtilsInput = {
  muted?: boolean | null
  autoplay?: boolean | null
  hideControls?: boolean | null
}

export const checkIsMuted = (videoConfig: VideoConfigUtilsInput): boolean => {
  return (
    checkIsControlsHidden(videoConfig) ||
    checkIsAutoplayEnabled(videoConfig) ||
    videoConfig?.muted !== false
  )
}

export const checkIsAutoplayEnabled = (
  videoConfig: VideoConfigUtilsInput
): boolean => {
  return checkIsControlsHidden(videoConfig) || videoConfig.autoplay !== false
}

export const checkIsControlsHidden = (
  videoConfig: VideoConfigUtilsInput
): boolean => {
  return videoConfig.hideControls === true
}
